import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import { ReportSectionHeader } from "../SectionHeader";



const PrelimDamagesComponent = (props) => (
    <div>
        <ReportSectionHeader>
        {props.isDandO === "true"?	"Total Maximum of Potential Rule 10b-5 Aggregate Damages" :
        	"Estimate of Maximum Potentially Available Rule 10b-5 Aggregate Damages"
        }
        	</ReportSectionHeader>

        <ReportTable
            settings={props.isDandO === "true"?[
                {
                    header: '', accessor: 'damageType',
                    map: {
                        APPLIED_INFLATION_RIBON: 'Applied Inflation Ribbon',
                        HOLDER_DAMAGES: 'Holder Investor Cohort (000s)',
                        TRADER_DAMAGES: 'Trader Investor Cohort (000s)',
                        COMPLETE_DAMAGES: 'Total Maximum of Potential Rule 10b-5 Damages (000s)'
                    }
                },
                {
                    header: 'Max. Potential Damages',
                    accessor: 'maxDollarOfArtificialInflationPerShare',
                    dollarValue: true,
                    inThousands: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                },
            ]
            :
        	[
                {
                    header: '', accessor: 'damageType',
                    map: {
                        APPLIED_INFLATION_RIBON: 'Applied Inflation Ribbon',
                        HOLDER_DAMAGES: 'Holder Investor Cohort (000s)',
                        TRADER_DAMAGES: 'Trader Investor Cohort (000s)',
                        COMPLETE_DAMAGES: 'Estimate of Maximum Potentially Available Rule 10b-5 Damages (000s)'
                    }
                },
                {
                    header: 'Max. Artificial Inflation',
                    accessor: 'maxDollarOfArtificialInflationPerShare',
                    dollarValue: true,
                    inThousands: true,
                    formatNumberWithCommas: true,
                    truncateDecimal: true,
                },
            ]}
            data={props.aggregateDamages}
            name={"prelimDamages"}
            accumulator={"maxDollarOfArtificialInflationPerShare"}
            accumulatorDisplay={props.isDandO === "true"?"Total Maximum of Potential Rule 10b-5 Aggregate Damages (000s)" : "Estimate of Maximum Potentially Available Rule 10b-5 Damages (000s)"}

        />
    </div>
);


export default PrelimDamagesComponent;


// WEBPACK FOOTER //
// ./src/common/components/PrelimDamages/PrelimDamagesComponent.js